import classNames from 'classnames';
import React, { FC } from 'react';

import { Modal } from '../../../store/models/Modal';
import Button from '../Button/Button';
import classes from './SuccessModal.module.scss';

export interface SuccessModalProps {
  modal?: Modal;
  className?: string;
}

const SuccessModal: FC<SuccessModalProps> = ({ modal, className }) => {
  return (
    <div className={classNames(classes.Container, className)}>
      {modal.icon && <img src={modal.icon} alt={'success-icon'} />}
      <h2>{modal?.title}</h2>
      <div dangerouslySetInnerHTML={{ __html: modal?.body }} />
      <footer>
        {modal?.primaryButtonText ? (
          <Button className={classes.Primary} onClick={modal?.primaryAction}>
            {modal?.primaryButtonText}
          </Button>
        ) : null}
        {modal?.secondaryButtonText ? (
          <Button
            className={classes.Secondary}
            onClick={modal?.secondaryAction}
            variant="outlined"
          >
            {modal?.secondaryButtonText}
          </Button>
        ) : null}
      </footer>
    </div>
  );
};

export default SuccessModal;
